import { Form, useFormikContext } from "formik";
import { useSortContext } from "../../contexts/SortProvider";
import { FormattedMessage, useIntl } from "react-intl";
import Button, { BUTTON_SIZES } from "app/pages/.shared/form/Button";
import { TripAdvisor } from "app/icons/brands";
import { SORT_OPTIONS } from "../../constants/sortOptions";
import { RadioIcon } from "app/icons/controls";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./SortPopoverForm.scss";

export const SortPopoverForm = () => {
	const { options } = useSortContext();
	const { values, setFieldValue } = useFormikContext();
	const { formatMessage } = useIntl();
	return (
		<Form className="sort-popover-form">
			<fieldset>
				<legend className="sr-only">
					<FormattedMessage id="sort.sort.options.screen.reader" />
				</legend>

				<ul className="sort-popover-form__options">
					{Object.values(options).map(option => {
						const isChecked = values?.sortBy === option.id;

						return (
							<li key={option.id} className="sort-popover-form__option">
								<input
									type="radio"
									id={option.id}
									name="sortBy"
									checked={isChecked}
									onChange={() => setFieldValue("sortBy", option.id)}
									className="sort-popover-form__radio-input sr-only"
								/>

								<label
									htmlFor={option.id}
									className="sort-popover-form__radio-label"
								>
									<span
										className="sort-popover-form__radio-icon"
										aria-hidden="true"
									>
										<RadioIcon checked={isChecked} />
									</span>

									<Typography
										variant={TYPOGRAPHY_VARIANTS.REGULAR}
										component="span"
										className="sort-popover-form__radio-label-text"
									>
										<FormattedMessage id={option.labelKey} />
									</Typography>

									{option.id === SORT_OPTIONS.RATING_DESC.id && <TripAdvisor />}
								</label>
							</li>
						);
					})}
				</ul>
			</fieldset>

			<footer className="sort-popover-form__footer">
				<Button
					size={BUTTON_SIZES.SMALL}
					className="sort-popover-form__apply-button"
					type="submit"
					label={formatMessage({
						id: "sdp.filter.apply.button.label",
					})}
				/>
			</footer>
		</Form>
	);
};
